const SET_PARTNER_STATUS = '@help-home/set-partner-status';

export { SET_PARTNER_STATUS };
